<template>
    <section>

        <div v-if="show">
            <b-form @submit="onSubmit" @reset="onReset" >
                <b-form-group id="input-group-2"   label-for="input-2">
                    <b-form-input
                            id="input-2"
                            v-model="form.name"
                            required
                            placeholder="Enter name"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                        id="input-group-1"

                        label-for="input-1"

                >
                    <b-form-input
                            id="input-1"
                            v-model="form.email"
                            type="email"
                            required
                            placeholder="Enter email"
                    ></b-form-input>
                </b-form-group>


                <b-form-group id="input-group-3"   label-for="input-3">
                    <b-form-input
                            id="input-3"
                            v-model="form.phone"

                            placeholder="Enter Phone Number"
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-4"   label-for="input-4">
                    <b-form-input
                            id="input-2"
                            v-model="form.subject"
                            required
                            placeholder="Subject"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-6"   label-for="input-6">

                    <b-form-input class=" d-none"
                            id="input-6"
                            v-model="form.web_url"

                            placeholder="Web URL"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-5"  class="text-left  " label="Question or Comment:" label-for="input-5">
                    <b-form-textarea
                            id="textarea"
                            v-model="form.message"
                            placeholder="Enter something..."
                            rows="3"
                            max-rows="6"
                    ></b-form-textarea>
                </b-form-group>


                <b-button type="submit"  class="site_button float-right">Submit Questions or Comments</b-button>

            </b-form>

        </div>
        <div v-else>
            <b-row>
                <b-col>
                    <h2>Thank you for your form submission </h2>
                    <div v-if="honeypot">
                        URL Submitted!!!!
                        <div>{{ success}}</div>
                        </div>
                    <div v-else>
                        {{ success}}
                    </div>
                </b-col>
            </b-row>


        </div>


    </section>
</template>

<script>



    export default {
        components: {

        },

        data ()  {
            return {
                apiUrl: this.appConfig.apiUrl,
                auth_username: this.appConfig.auth_username,
                auth_password: this.appConfig.auth_password,
                localdata: [],
                posts: [],
                status: null,
                form: {
                    webform_id: 'springfield_net_contact',
                    email: '',
                    name: '',
                    subject: '',
                    phone: '',
                    web_url: '',
                    message: ''


                },

                show: true,
                honeypot: false,
                success: '',
                recaptchaToken: null,
                ip_results:[]
            }


        },
        methods: {
            submitButtonClicked () {
                this.$refs.invisibleRecaptcha1.execute()
            },

            recaptchaCallback(recaptchaToken){
                console.log(recaptchaToken)
                this.recaptchaToken = recaptchaToken
            },

            removeToken() {
                this.recaptchaToken = null
            },
            onSubmit(evt) {
                evt.preventDefault()
                //   alert(JSON.stringify(this.form))
                if(this.form.web_url === ""){

                        this.postData();

                }else{
                    //honey pot!!!!
                    this.success = 'Data saved successfully';
                    this.show = false
                    this.honeypot=true
                }

            },
            onReset(evt) {
                evt.preventDefault()
                // Reset our form values
                this.form.email = ''
                this.form.name = ''
                this.form.subject = ''
                this.form.message = ''
                this.form.web_url = ''



                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            },
            postData: function () {
                this.ajaxRequest = true;

                this.form.client_ip=this.ip_results.ip


                const payload = JSON.stringify(this.form)

/*
                let axconfig = {
                    method: 'post',
                    url:  this.apiUrl + '/webform_rest/submit?_format=json',
                    headers: { 'Content-Type': 'application/json'}
                };

                axios(axconfig)
*/
                this.axios.post(this.apiUrl + '/webform_rest/submit?_format=json',
               //     this.axios.post('https://jsonplaceholder.typicode.com/posts',
                    payload,
                    {
                        headers: {
                            'Content-Type': 'application/json'

                        },
                        auth: {
                            username:  this.auth_username,
                            password:  this.auth_password
                        }
                    },
                ).then(response => {
                 //   console.log(response);
                    // this.response = response.data
                    this.success = 'Data saved successfully';
                    // this.response = JSON.stringify(response, null, 2)
                    this.response = JSON.parse(response.data)
                    this.show = false
                    // this.ajaxRequest = false;
                    this.status=this.response.status
                 //   console.log(this.status)
                }).catch(error => {
                    this.response = 'Error: ' + error.response

                    this.status="Failed"
                })
                this.show = false
            },
            getUserip(){
                this.axios.get('https://api.ipify.org?format=json').then(response => {
                  //  console.log(response.data)
                    this.ip_results = response.data
                })
            }
        },
        mounted() {
            this.getUserip()
          //  this.fetchData()

        }


    }

</script>

<style>
    button.site_button{
        background: #333366;

    }
</style>
